import { createUseStyles } from '@glu/theming';

const styles = ({ nav = {}, menuHighlight }) => ({
  linkText: {
    overflow: 'hidden',
    // fix hanging text getting chopped from overflow https://jira.us-bottomline.root.bottomline.com/browse/CB-20389
    paddingBottom: '4px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: nav?.color || '#000000'
  },
  menuHighlight
});

export default createUseStyles(styles);
